import { CredentialField } from "../shared/CredentialField";

/**
 * Credentials form for the Slack BYO-token integration.
 * The customer pastes their own internal Slack app's bot token (xoxb-...).
 * See docs/integrations/slack-byo-token-setup.md in the backend repo.
 */
export const SlackCredentialsForm = ({ credentials, onCredentialsChange }) => {
  const handleChange = (field) => (value) => {
    onCredentialsChange((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="px-6 pb-4">
      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        Connect Slack with a bot token
      </h3>
      <p className="mb-4 text-sm text-gray-500">
        Create a Slack app in your workspace, add the read scopes, install it,
        and paste its <span className="font-medium">Bot User OAuth Token</span>{" "}
        (starts with <code>xoxb-</code>) below. Then invite the bot to each
        client channel with <code>/invite @Panora</code>.
      </p>

      <div className="space-y-4">
        <CredentialField
          id="slack_bot_token"
          label="Bot User OAuth Token"
          type="password"
          tooltip="Slack app → OAuth & Permissions → Bot User OAuth Token (xoxb-...)"
          placeholder="xoxb-..."
          value={credentials.token}
          onChange={handleChange("token")}
        />
        <CredentialField
          id="slack_team_domains"
          label="Your team's email domain(s)"
          tooltip="Comma-separated, e.g. unitary.ai. Used to tell your staff apart from your clients so only the client's voice drives signals."
          placeholder="unitary.ai, unitary.com"
          value={credentials.teamDomains}
          onChange={handleChange("teamDomains")}
        />
      </div>
    </div>
  );
};
